module.exports = __webpack_public_path__ + "img/_icon-informed-delivery.4849618c.svg";